import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import appConfig from '../../utils/appConfig';

const TYPE_PAY = 'אשראי';

const CreditcardPay: React.FC = () => {
  const location = useLocation();
  const { idNumber, email, selectedStation, serverData, acceptTerms,grade,parentName,phone,amount,externalSchoolsForm, schedulingId, period } = location.state || {};


  const { authorityName } = useParams<{ authorityName: string }>();

  const authority = appConfig.authorities.find(auth => auth.en === authorityName);

  const sum = externalSchoolsForm? amount:serverData.price;
  const supplier = authority?.tranzilaCode; // יש להחליף לפי שם המסוף שלך
  const currency = 1;
  //const email = email;
  const cred_type = 8; // סוג עסקה. 8 מייצג תשלומים
  const maxpay = 10; // מספר תשלומים
  const lang = "il";
  const contact = serverData.name;
  const ID_child = idNumber;
  const user_defined_3 = email;
  // תשלום עבור הסעות + שם התלמיד + ת.ז + תקופה
  const paymentDescription = `תשלום עבור הסעות ${serverData.name} ${idNumber} ${period || appConfig.year}`;
  const user_defined_7 = paymentDescription;
  const user_defined_8 = idNumber;
  const pdesc = paymentDescription;
  const remarks = paymentDescription;
  const user_id = idNumber;
  const type = "הסעה"
  // Bare URL, no query string - a previous attempt embedded schedulingId/typePay as a
  // nested query string here and it appears to have contributed to Tranzila's own page
  // erroring out (500 from their /process/n/ endpoint). schedulingId now travels via
  // user_defined_1, Tranzila's own supported mechanism for round-tripping business data.
  // Must be a fully-qualified absolute URL (scheme+host) - Tranzila's own backend
  // resolves this, it has no notion of "relative to our domain".
  const thankYouUrl = `${window.location.origin}/api/thankYouPage/creditcard`;

  // שמירת הנתונים ב-Session Storage לפני טעינת ה-iframe
  sessionStorage.setItem('paymentDetails', JSON.stringify({
    idNumber,
    email,
    selectedStation,
    serverData,
    acceptTerms,
    grade,parentName,phone,amount,externalSchoolsForm
  }));

  // Built with URLSearchParams (not a hand-built multi-line template string) so no stray
  // whitespace/newlines from source indentation leak into parameter values - a previous
  // version glued trailing whitespace onto lang/email/nologo etc., which is what was
  // actually crashing Tranzila's own in-page JS (convertToCcno) on keystroke.
  const iframeParams = new URLSearchParams({
    sum: String(sum ?? ''),
    currency: String(currency),
    cred_type: String(cred_type),
    maxpay: String(maxpay),
    lang,
    user_defined_1: schedulingId || '',
    Scheduling: schedulingId || '',
    user_defined_3: user_defined_3 || '',
    user_defined_7,
    user_defined_8: user_defined_8 || '',
    email: email || '',
    pdesc,
    remarks,
    user_id: user_id || '',
    contact: contact || '',
    ID_child: ID_child || '',
    type,
    nologo: '1',
    success_url_address: thankYouUrl,
    fail_url_address: thankYouUrl,
  });
  const iframeUrl = `https://direct.tranzila.com/${supplier}/iframenew.php?${iframeParams.toString()}`;

  // Tranzila's iframe runs the payment form same-page and reports the result via
  // postMessage to the parent window rather than a top-level browser redirect - this
  // is the mechanism that actually fires in practice (success_url_address above is
  // kept as a fallback, and the server dedupes if both end up firing).
  const alreadyFinalized = useRef(false);
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://direct.tranzila.com') return;

      // eslint-disable-next-line no-console
      console.log('[Tranzila] postMessage received | origin:', event.origin, '| raw data:', event.data);

      let response: any;
      try {
        response = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      } catch (e) {
        console.error('[Tranzila] failed to parse postMessage data:', e);
        return;
      }
      // eslint-disable-next-line no-console
      console.log('[Tranzila] parsed payment response:', response);

      const isSuccess = response?.success === true || response?.Response === '000' || response?.response === '000';
      if (!isSuccess) {
        console.log('[Tranzila] payment not successful per postMessage - not finalizing');
        return;
      }
      if (alreadyFinalized.current) return;
      alreadyFinalized.current = true;

      fetch(`${appConfig.apiUrls.baseUrl}/zohoPayments/finalizePayment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          schedulingId,
          typePay: TYPE_PAY,
          amount: response.sum ?? sum,
          confirmationNumber: response.confirmationCode,
          asmahta: response.confirmationCode,
          idCardHolder: idNumber,
          // שם המסוף (child_terminal בזוהו) - אותו מסוף שבו בוצעה עסקת האשראי
          terminalName: supplier,
        }),
      }).then(res => res.json())
        .then(data => console.log('[Tranzila] finalizePayment result:', data))
        .catch(err => console.error('[Tranzila] finalizePayment request failed:', err));
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [schedulingId, idNumber, sum, supplier]);

  return (
    <Box sx={{ maxWidth: 400, margin: '0 auto', padding: 2 }}>
      <Typography
        variant="h6"
        sx={{
          marginBottom: 2,
          textAlign: 'center',
          padding: 2,
          backgroundColor: '#f0f4f8',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          border: '1px solid #ddd',
        }}
      >
        <span style={{ fontWeight: 'bold', color: '#333' }}>שם הילד:</span> {serverData.name}
        {!externalSchoolsForm && (
              <div>
                <span style={{ fontWeight: 'bold', color: '#333' }}>
                  שם המוסד:
                </span> 
                {serverData.institution}
              </div>
            )}
             {externalSchoolsForm && (
        <br />
      )}
        <span style={{ fontWeight: 'bold', color: '#333' }}>סכום לתשלום:</span> ₪{sum}
        {!externalSchoolsForm && (
              <div>
                <span style={{ fontWeight: 'bold', color: '#333' }}>
                 תחנת עליה: 
                </span> 
                {selectedStation}
              </div>
            )}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
      <div style={{ width: '370px',backgroundColor:'white', height: '455px', overflow: 'hidden', position: 'relative', border: '1px solid #ddd', borderRadius: '8px' }}>
      <iframe
        src={iframeUrl}
        frameBorder="0"
        scrolling="no"
        title="Tranzila Payment"
        style={{
          width: '460px', // גודל מותאם של ה-iframe
          height: '700px', // גודל מותאם של ה-iframe
          transform: 'scale(0.8)', // שינוי ה-scale כדי להתאים את הגודל לתוך ה-div
          transformOrigin: 'top left',
          position: 'absolute',
          top: '0',
          left: '0',
          marginTop:'50px',
        }}
      ></iframe>
    </div>
      </Box>
    </Box>
  );
};

export default CreditcardPay;
